import type {
    TResponseGetDealFiles,
    TFileInfo,
    TExtractionInfo,
    TFileType,
} from "@/apis/odin/apiODIN";

type AddExtractionRow = {
    addExtraction: boolean;
    fileId: number;
    projectId: number;
    databaseId: number;
    parentFileName: string;
};

export type FileExtractionInfo =
    | (TFileInfo & {
          isParent: boolean;
          allowUserDeletion: boolean;
          status?: "with_proda";
      })
    | (TExtractionInfo & {
          originalFilename?: string;
          uploadedAt?: string;
          uploadedBy?: string;
          fileType?: TFileType | null;
          parentFileName: string;
          databaseId: number;
          allowUserDeletion: boolean;
      })
    | AddExtractionRow;

export const transformFileView = (
    dealFiles: TResponseGetDealFiles["files"],
): FileExtractionInfo[] => {
    return dealFiles.flatMap(file => {
        if (
            file.fileInfo.deletedAt !== undefined &&
            file.fileInfo.deletedAt !== null
        ) {
            return [];
        }
        const parentRow: TFileInfo & {
            isParent: boolean;
            allowUserDeletion: boolean;
            status?: "with_proda";
        } = {
            ...file.fileInfo,
            isParent: true,
            allowUserDeletion: file.allowUserDeletion,
        };
        if (file.fileInfo.withProda === true) {
            parentRow.status = "with_proda" as const;
        }
        const childRows = file.extractions.map(extraction => ({
            ...extraction,
            parentFileName: file.fileInfo.originalFilename,
            originalFilename: file.fileInfo.originalFilename,
            uploadedAt: extraction.createdAt,
            uploadedBy: extraction.createdBy,
            fileType: file.fileInfo.fileType,
            databaseId: file.fileInfo.databaseId,
            modifiedBy: extraction.modifiedBy ?? extraction.createdBy,
            type: extraction.extractionType,
            allowUserDeletion: file.allowUserDeletion,
        }));
        const addExtractionRow: AddExtractionRow = {
            addExtraction: true,
            parentFileName: file.fileInfo.originalFilename,
            fileId: file.fileInfo.fileId,
            projectId: file.fileInfo.projectId,
            databaseId: file.fileInfo.databaseId,
        };
        return [
            parentRow,
            ...(childRows.length > 0 ||
            (file.fileInfo.deletedAt !== null &&
                file.fileInfo.deletedAt !== undefined) ||
            (childRows.length === 0 && file.fileInfo.withProda === true)
                ? childRows
                : [addExtractionRow]),
        ];
    });
};
